// extracted by mini-css-extract-plugin
export default {"loader__spiner-text":"loader_loader__spiner-text__iJtgR"};